<form [formGroup]="formGroup">
    <BI-grid-layout [rows]="rowsList" [cols]="['auto','auto']" [gap]="3" class="grid-layout-container">
      <ng-container *ngFor="let control of controlList" [ngSwitch]="control.controlType">

        <BI-grid-layout-item [col]="control.colNumber" [row]="control.rowNumber" *ngSwitchCase="'empty'">
          <BI-grid-layout [rows]="['auto','auto']" [cols]="['auto']" [gap]="3">
            <BI-grid-layout-item [row]="1" [col]="1">

            </BI-grid-layout-item>
            <BI-grid-layout-item [row]="2" [col]="1">

            </BI-grid-layout-item>
          </BI-grid-layout>
        </BI-grid-layout-item>

        <BI-grid-layout-item [col]="control.colNumber" [row]="control.rowNumber" *ngSwitchCase="'title'">
          <BI-grid-layout [rows]="['auto']" [cols]="['auto']" [gap]="3">
            <BI-grid-layout-item [row]="1" [col]="1">
              <h5 class="grid-title m-0">{{control.DisplayName|
                translate}}</h5>
            </BI-grid-layout-item>
          </BI-grid-layout>
        </BI-grid-layout-item>

        <BI-grid-layout-item [col]="control.colNumber" [row]="control.rowNumber" *ngSwitchCase="'text'">
          <ng-container>
            <BI-grid-layout [rows]="['auto']" [cols]="['98%']" [gap]="3" *ngIf="control.IsVisible">

              <BI-grid-layout-item [row]="1" [col]="1" *ngIf="control.TextAfterInput">
                <BI-grid-layout [rows]="['auto']" [cols]="['71%','27%']">
                  <BI-grid-layout-item [row]="1" [col]="1">
                    <ng-container *ngTemplateOutlet="textInput"></ng-container>
                  </BI-grid-layout-item>

                  <BI-grid-layout-item [row]="1" [col]="2">
                    <span>{{ control.TextAfterInput}} </span>
                  </BI-grid-layout-item>
                </BI-grid-layout>
              </BI-grid-layout-item>

              <BI-grid-layout-item [row]="1" [col]="1" *ngIf="!control.TextAfterInput">
                <ng-container *ngTemplateOutlet="textInput"></ng-container>
              </BI-grid-layout-item>

              <ng-template #textInput>
                <kendo-floatinglabel text="{{control.DisplayName}}">
                  <input [formControlName]="control.Name" [id]="'input_'+control.Name" type="text"
                    class="form-control w-100" [style]="control.Style" [mask]="control?.Mask"
                    [showMaskTyped]="control?.Mask? true: false" />
                </kendo-floatinglabel>
                <bi-render-validator-msg [formGroup]="formGroup" [control]="control"></bi-render-validator-msg>
              </ng-template>

            </BI-grid-layout>
          </ng-container>
        </BI-grid-layout-item>

        <BI-grid-layout-item [col]="control.colNumber" [row]="control.rowNumber" *ngSwitchCase="'checkbox'">
          <BI-grid-layout [rows]="['auto']" [cols]="['40%','58%']" [gap]="3" *ngIf="control.IsVisible">
            <BI-grid-layout-item [row]="1" [col]="1">
              <label class="labels" [for]="control.Name">{{control.DisplayName
                |
                translate}}</label>
            </BI-grid-layout-item>

            <BI-grid-layout-item [row]="1" [col]="2" *ngIf="control.TextAfterInput">
              <BI-grid-layout [rows]="['auto']" [cols]="['71%','27%']">
                <BI-grid-layout-item [row]="1" [col]="1">
                  <ng-container *ngTemplateOutlet="checkboxInput"></ng-container>
                </BI-grid-layout-item>

                <BI-grid-layout-item [row]="1" [col]="2">
                  <span>{{ control.TextAfterInput}} </span>
                </BI-grid-layout-item>
              </BI-grid-layout>
            </BI-grid-layout-item>

            <BI-grid-layout-item [row]="1" [col]="2" *ngIf="!control.TextAfterInput">
              <ng-container *ngTemplateOutlet="checkboxInput"></ng-container>
            </BI-grid-layout-item>

            <ng-template #checkboxInput>
              <input [formControlName]="control.Name" [id]="'input_'+control.Name" type="checkbox"
                class="form-check-input" />
            </ng-template>

          </BI-grid-layout>
        </BI-grid-layout-item>


        <BI-grid-layout-item [col]="control.colNumber" [row]="control.rowNumber" *ngSwitchCase="'number'">
          <ng-container>
            <BI-grid-layout *ngIf="control.IsVisible" [rows]="['auto']" [cols]="['40%','58%']" [gap]="3">
              <BI-grid-layout-item [row]="1" [col]="1">
                <label class="labels" [for]="control.Name">{{control.DisplayName
                  |
                  translate}}</label>
              </BI-grid-layout-item>

              <BI-grid-layout-item [row]="1" [col]="2" *ngIf="control.TextAfterInput">
                <BI-grid-layout [rows]="['auto']" [cols]="['71%','27%']">
                  <BI-grid-layout-item [row]="1" [col]="1">
                    <ng-container *ngTemplateOutlet="numericInput"></ng-container>
                  </BI-grid-layout-item>

                  <BI-grid-layout-item [row]="1" [col]="2">
                    <span>{{ control.TextAfterInput}} </span>
                  </BI-grid-layout-item>
                </BI-grid-layout>
              </BI-grid-layout-item>

              <BI-grid-layout-item [row]="1" [col]="2" *ngIf="!control.TextAfterInput">
                <ng-container *ngTemplateOutlet="numericInput"></ng-container>
              </BI-grid-layout-item>

              <ng-template #numericInput>
                <input [formControlName]="control.Name" [id]="'input_'+control.Name" type="number"
                  class="form-control w-100" [style]="control.Style" />
                <bi-render-validator-msg [formGroup]="formGroup" [control]="control"></bi-render-validator-msg>
              </ng-template>

            </BI-grid-layout>
          </ng-container>
        </BI-grid-layout-item>



        <BI-grid-layout-item [col]="control.colNumber" [row]="control.rowNumber" *ngSwitchCase="'lookup'">
          <BI-grid-layout [rows]="['auto']" [cols]="['40%','58%']" [gap]="3" *ngIf="control.IsVisible">
            <BI-grid-layout-item [row]="1" [col]="1">
              <label class="labels" [for]="control.Name">{{control.DisplayName
                |
                translate}}</label>
            </BI-grid-layout-item>
            <BI-grid-layout-item [row]="1" [col]="2">
              <app-bi-lookup [DataSource]="control.lookupTemplate?.DataSource"
                [BindingProperty]="asFormControl(formGroup.get(control.Name))" [Key]="control.lookupTemplate?.Key"
                [DomID]="control.Name" [Title]="control.DisplayName" [style]="control.Style">
              </app-bi-lookup>
              <bi-render-validator-msg [formGroup]="formGroup" [control]="control"></bi-render-validator-msg>
              <div>
              </div>
            </BI-grid-layout-item>
          </BI-grid-layout>

        </BI-grid-layout-item>

        <BI-grid-layout-item [col]="control.colNumber" [row]="control.rowNumber" *ngSwitchCase="'select'">
          <BI-grid-layout [rows]="['auto']" [cols]="['40%','58%']" [gap]="3" *ngIf="control.IsVisible">
            <BI-grid-layout-item [row]="1" [col]="1">
              <label class="labels" [for]="control.Name">{{control.DisplayName|
                translate}}</label>
            </BI-grid-layout-item>
            <BI-grid-layout-item [row]="1" [col]="2">
              <bi-dropDown [BindingProperty]="asFormControl(formGroup.get(control.Name))"
                [DropDownList]="control.dropDownTemplate?.list" [ValueField]="control.dropDownTemplate?.value"
                [TextField]="control.dropDownTemplate?.text" [style]="control.Style">
                <bi-render-validator-msg [formGroup]="formGroup" [control]="control"></bi-render-validator-msg>
              </bi-dropDown>
            </BI-grid-layout-item>
          </BI-grid-layout>
        </BI-grid-layout-item>

        <BI-grid-layout-item [col]="control.colNumber" [row]="control.rowNumber" *ngSwitchCase="'date'">
          <BI-grid-layout [rows]="['auto']" [cols]="['40%','58%']" [gap]="3">
            <BI-grid-layout-item [row]="1" [col]="1">
              <label class="labels" [for]="control?.Name">{{control.DisplayName|translate}}</label>
            </BI-grid-layout-item>
            <BI-grid-layout-item [row]="1" [col]="2">
              <kendo-datepicker [formControlName]="control.Name" class="form-control d-flex p-0" [style]="control.Style"
                calendarType="classic"></kendo-datepicker>
              <bi-render-validator-msg [formGroup]="formGroup" [control]="control"></bi-render-validator-msg>
            </BI-grid-layout-item>
          </BI-grid-layout>
        </BI-grid-layout-item>

      </ng-container>
    </BI-grid-layout>
</form>